@if(loader){
  <app-loader></app-loader>
}

  <p-card>
      <div class="">
        <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
          <div class="flex align-items-center">
            <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" (click)="CreateAssignRole()" size="small"
              pTooltip="Create Assign Roles"></p-button>
      
            <!-- <p-button *ngIf="selectedCompany && selectedCompany.length > 0" label="Delete" class="ml-2"
                                      icon="pi pi-trash" (click)="deleteCompany()" size="small" severity="danger"></p-button> -->
      
            <div class="flex align-items-center ml-3">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                  (keyup.enter)="searchAssignRoles()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
              </span>
              <p-button icon="pi pi-search" (onClick)="searchAssignRoles()" [ngStyle]="{ height: '35px' }" [raised]="true"
                [size]="'small'" severity="info" class="ml-2"></p-button>
            </div>
      
            <p-button *ngIf="selectedAssignRole && selectedAssignRole.length == 1" label="Edit" class="ml-2"
              icon="pi pi-user-edit" (click)="editComapny()" size="small" severity="secondary"></p-button>
          </div>
          <h2 class="page-title-center">Assign Role List</h2>
      
      
          <div class="flex">
            <div class="flex align-items-center">
              <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                severity="info"></p-button>
            </div>
          </div>
        </div>


          <p-table #dt1 [value]="result.assignRole" [scrollable]="false" styleClass="p-datatable-striped" class="w-full m-5" styleClass="p-datatable-sm" scrollHeight="650px"
          [paginator]="true" [rows]="10" [globalFilterFields]="['assignRoleId']"
          (onPage)="loadassignroleinfo($event)" [(selection)]="selectedAssignRole"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,15, 20]" [rowHover]="true" [selectionPageOnly]="true">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 4rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th>Assign Role Code</th>
              <th>Assign Role Name</th>
              <th>RoleId</th>
              <th>MenuId</th>
              <th>SubmenuId</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-role>
            <tr>
              <td>
                <p-tableCheckbox [value]="role"></p-tableCheckbox>
              </td>
              <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editComapny(role.roleId)">
                {{role.assignRoleId}}
              </td>
              <td>{{role.description}}</td>
              <td>{{role.roleId}}</td>
              <td>{{role.menuId}}</td>
              <td>{{role.subMenuId}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">No Records found.</td>
            </tr>
        </ng-template>
        </p-table>
      </div>
      </p-card>

  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>
